export const ExternalPlayIcon = (props: React.SVGProps<SVGSVGElement>) => (
  <svg
    xmlns='http://www.w3.org/2000/svg'
    width='20'
    height='20'
    viewBox='0 0 24 24'
    fill='none'
    stroke='currentColor'
    strokeWidth={2}
    strokeLinecap='round'
    strokeLinejoin='round'
    {...props}
  >
    {/* Window (web page) outline */}
    <rect x='3' y='4' width='18' height='16' rx='2' />
    {/* Top bar */}
    <path d='M3 7.5h18' />
    {/* Upward arrow from bottom to top inside the window */}
    <path d='M12 18v-6' />
    <path d='M9 12l3-3 3 3' />
  </svg>
);
